import { push } from 'connected-react-router';
import _get from 'lodash/get';
import ApiManager from 'utils/ApiManager';
import errorCatch from 'utils/errorCatch';
import PromiseAll from 'utils/PromiseAll';
import createURLWithQuery from 'utils/createURLWithQuery';

export const actionTypes = {
  SET_SPECIALIZATIONS: 'PATIENT_VIEW/SET_SPECIALIZATIONS',
  SET_CLINIC_DATA: 'PATIENT_VIEW/SET_CLINIC_DATA',
};

export const initialState = {
  specializations: [],
  clinicData: {
    hasIndividualExaminationsEnabled: false,
    clinicTypeName: '',
  },
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_SPECIALIZATIONS:
      return {
        ...state,
        specializations: action.specializations,
      };
    case actionTypes.SET_CLINIC_DATA:
      return {
        ...state,
        clinicData: {
          hasIndividualExaminationsEnabled: action.clinicData.has_individual_examinations_enabled,
          clinicTypeName: action.clinicData.clinic_type_name,
        },
      };
    default:
      return state;
  }
};

export const setSpecializations = (specializations) => ({
  type: actionTypes.SET_SPECIALIZATIONS,
  specializations,
});

export const setClinicData = (clinicData) => ({
  type: actionTypes.SET_CLINIC_DATA,
  clinicData,
});

export const onStart = (routeState, userWithEmail) => (dispatch) => {
  dispatch(push('/researchStart', { patientID: routeState.id, userWithEmail }));
};

export const onGoBackToList = () => (dispatch) => {
  dispatch(push('/patients'));
};

const getSpecializations = () => (dispatch) => ApiManager.request('get', dispatch, 'specializations?orderBy=id&sortedBy=asc');

const getClinic = (clinicID) => (dispatch) => {
  const params = {
    with_clinic_coordinator: 1,
    append_balance: true,
    append_has_session_patients_in_clinic: true,
    append_clinic_type_name: true,
  };

  const url = createURLWithQuery(`clinics/${clinicID}`, params);

  return ApiManager.request('get', dispatch, url);
};

export const loadPageData = () => (dispatch, getStore) => {
  const { userData } = getStore().Global;
  const clinicId = _get(userData, 'clinics[0].id');

  const promises = {
    specializations: dispatch(getSpecializations()),
    clinicData: dispatch(getClinic(clinicId)),
  };

  return PromiseAll(promises).then((responses) => {
    dispatch(setSpecializations(responses.specializations.data));
    dispatch(setClinicData(responses.clinicData.data));

    return Promise.resolve();
  }).catch((err) => {
    errorCatch(err, dispatch, true, true);
  });
};
